import React from 'react'

import { Wordbook } from '@Components/Wordbook'
import { useAddon } from '@Domains/Product/Addons/hooks'
import { UpSellItem } from '@Domains/Product/Features/Display/UpSellItem/UpSellItem'
import { ProductPageTacticFragmentFragment } from '@Generated/graphql'
import { createAddToCartTacticFromOffer } from '@Shared/Utilities/AddToCartHelper'

import styles from './MatchingVariant.module.scss'

type Tactic = Extract<ProductPageTacticFragmentFragment, { __typename: 'TacticMatchingVariant' }>

export const MatchingVariantTactic = ({
  tactic,
}: {
  tactic: Tactic
}) => {
  const [isSelected, setIsSelected] = useAddon([
    {
      productID: tactic.product?.id || '',
      quantity: 1,
      ...tactic.offer && tactic.offer.price && {
        parentIndex: 0,
        tactic: createAddToCartTacticFromOffer(tactic.offer),
      },
    },
  ])

  if (!tactic.product || !tactic.productID) {
    return null
  }

  return (
    <div className={styles.productPage}>
      <div className={styles.matchingVariantTitle}><Wordbook wordbook={tactic.title} /></div>
      <UpSellItem
        offer={tactic.offer || undefined}
        onChange={e => setIsSelected(e.target.checked)}
        product={tactic.product || undefined}
        productHeader={tactic.productHeader || undefined}
        selected={isSelected}
        size="large"
      />
    </div>
  )
}
